import { Box, Link } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { EvaluationSourcesType } from '@/service/types';

type LinkCellProps = {
  url: EvaluationSourcesType['url'];
};

export const LinkCell = ({ url }: LinkCellProps) => (
  <Box display='flex' alignItems='center' gap={1}>
    <LinkIcon />
    <Link
      href={/^https?:\/\//i.test(url) ? url : 'https://' + url}
      underline='hover'
      target='_blank'
      rel='noopener'
      color='ButtonText'
      sx={{ overflowWrap: 'anywhere' }}
    >
      {url}
    </Link>
  </Box>
);
